export const cepValidator = (value: string) => {
  value = String(value);
  const cep = value.replace(/\D/g, '');
  if (!cep) {
    return false;
  }
  const cepRegex = /^[0-9]{8}$/;
  return cepRegex.test(cep);
};
